import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EndPointApi } from '@helpers/endpointapi';

@Injectable({ providedIn: 'root' })
export class AzureAuthService {
    private domain: string;

    constructor(public dialog: MatDialog) {
        this.domain = EndPointApi.iApiDomain();
    }

    azureLogIn() {
        window.location.href = `${this.domain}/api/azure/login`;
    }

    azureLogOut() {
        window.location.href = `${this.domain}/api/azure/logout`;
    }
}
